<div class="dialog-header">
  <div class="dialog-title" [innerHTML]="confirmationDialog.title"></div>
</div>
<span [innerHTML]="confirmationDialog.message"></span>
<div class="dialog-footer">
  <button style="float:left" mat-raised-button color="primary" type="submit" [mat-dialog-close]="true">{{confirmationDialog.okButtonTitle}}</button>
  <button style="float:right" mat-raised-button color="accent" type="submit" [mat-dialog-close]="false">{{confirmationDialog.cancelButtonTitle}}</button>
</div>